<template>
  <div class="page page--fill">
    <data-list
      ref="list"
      title="Clés d'API"
      resource="api-keys"
      :columns="columns">
      <template #actions>
        <v-btn
          color="primary"
          depressed
          @click="showDialog = true">
          <v-icon
            left
            small>
            mdi-plus
          </v-icon>
          Nouvelle clé
        </v-btn>
      </template>
      <template #name="{ item }">
        <span class="cell-strong">{{ item.name }}</span>
      </template>
      <template #value="{ item }">
        <span class="cell-mono">{{ item.value }}</span>
        <v-btn
          icon
          x-small
          title="Copier"
          @click.stop="copy(item.value)">
          <v-icon x-small>
            mdi-content-copy
          </v-icon>
        </v-btn>
      </template>
      <template #user="{ item }">
        <template v-if="item.user">
          <div>{{ item.user.email }}</div>
          <div class="cell-muted">
            {{ item.user.account && item.user.account.name }}
          </div>
        </template>
        <span v-else>—</span>
      </template>
      <template #row_actions="{ item }">
        <v-btn
          icon
          small
          title="Supprimer"
          @click.stop="deleteItem(item)">
          <v-icon
            small
            color="error">
            mdi-trash-can-outline
          </v-icon>
        </v-btn>
      </template>
    </data-list>

    <api-key-modal
      :show-dialog="showDialog"
      @close="showDialog = false"
      @submit="addKey" />
  </div>
</template>

<script>
  import DataList from '../components/DataList'
  import ApiKeyModal from '../components/ApiKeyModal'

  export default {
    name: 'ApiKeyList',
    components: { DataList, ApiKeyModal },
    data () {
      return {
        showDialog: false,
        columns: [
          { key: 'name', label: 'Nom' },
          { key: 'value', label: 'Clé' },
          { key: 'user', label: 'Utilisateur' },
          { key: 'row_actions', label: '', width: 60, align: 'end' }
        ]
      }
    },
    methods: {
      async addKey (payload) {
        try {
          await this.$api.axios.post('api-keys', payload)
          this.showDialog = false
          this.$awn.success('Clé créée')
          this.$refs.list.reload()
        } catch (e) {
          if (e.message !== 'Action annulée') this.$awn.alert('Impossible de créer la clé d\'API')
        }
      },
      async deleteItem (key) {
        const ok = await this.$confirm({
          title: 'Supprimer la clé ?',
          message: `La clé « ${key.name} » ne fonctionnera plus.`,
          confirmLabel: 'Supprimer',
          danger: true
        })
        if (!ok) return
        try {
          await this.$api.axios.delete(`api-keys/${key.pk}`)
          this.$awn.success('Clé supprimée')
          this.$refs.list.reload()
        } catch (e) {
          if (e.message !== 'Action annulée') this.$awn.alert('Impossible de supprimer cette clé')
        }
      },
      copy (value) {
        navigator.clipboard.writeText(value)
        this.$awn.success('Clé copiée')
      }
    }
  }
</script>
